import useCachedUser from '@/modules/user/hooks/useCachedUser'
const { getUser } = useCachedUser()

export default () => ({
  user: getUser() || {
    id: undefined,
    firstName: undefined,
    fullName: undefined,
    nationalId: undefined,
    council: undefined,
    email: undefined,
    roles: [],
    profileImageUrl: undefined,
    settings: {},
    permissions: {},
    healthCareTeams: []
  }
})
